import { http } from "./api";
import { parseEvents } from "./eventAPI";

// Everything the calendar needs to open. The events cover `months` ('YYYY-MM') in this browser's time zone.
export const getBootstrapAPI = () => {
  return http.get('/bootstrap', {
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`
    },
    params: {
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone
    },
    timeout: 30000,
  }).then((res) => ({ ...res.data, events: parseEvents(res.data.events) }));
}
